<template>
    <v-card flat>
        <v-card-text class="roompicker-page content-500">
          <h2 class="page-title">Room Picker</h2>

          <form>
            <div class="picker-form">
            <v-select
                class='select__campus'
                :disabled="roomsLoading"
                :loading="roomsLoading"
                v-bind:items="campuses"
                v-model="campusAndRegionSelection"
                item-text="label"
                label="Select Campus"
            ></v-select>
            <v-select
                class='select__building'
                :disabled="roomsLoading"
                :loading="roomsLoading"
                v-bind:items="buildings"
                v-model="buildingSelection"
                label="Select Building"
                autocomplete
            ></v-select>
            <v-select
                class='select__room'
                :disabled="roomsLoading"
                :loading="roomsLoading"
                v-bind:items="rooms"
                v-model="roomSelection"
                item-text="selectLabel"
                item-value="room_id"
                label="Select Room"
                autocomplete
            ></v-select>
            <div class="text-xs-center">
              <v-btn
                @click="resetForm()"
                :disabled="roomSelection === null && buildingSelection === null && campusSelection === null"
                class='btn__reset_form'
                color="error"
                flat
              >
                <v-icon left>remove_circle_outline</v-icon>
                <span class="btn__text">Clear Filters</span>
              </v-btn>
              <v-btn
                @click="startReport()"
                :disabled="roomSelection === null"
                class='btn__start_report'
              >
                <v-icon left>edit</v-icon>
                <span class="btn__text">Start Report</span>
              </v-btn>
            </div>
          </div>

          </form>

          <v-layout class="recent_room_checks mt-5" v-if="recentlyCheckedRooms.length">
            <v-flex>
                <div class="title mb-1">Recent Room Checks</div>
                <table class="table table__report">
                  <thead>
                    <tr>
                      <th role="columnheader" class="text-xs-left pr-1 pl-0 body-2 activity_column--room_label">Room</th>
                      <th role="columnheader" class="text-xs-right pr-0 pl-1 body-2 activity_column--room_last_checked">Last Check</th>
                    </tr>
                  </thead>
                  <template v-for="(item, index) in recentlyCheckedRooms">
                    <tr v-bind:key="index" ripple class="field">
                      <td class="text-xs-left py-1 pr-1 pl-0 body-1 activity_column--room_label">{{ item.label }}</td>
                      <td class="text-xs-right py-1 pr-0 pl-1 body-1 activity_column--room_last_checked"><em>{{ item.last_checked_time_ago }}</em></td>
                    </tr>
                  </template>
                </table>

            </v-flex>
          </v-layout>
        </v-card-text>
    </v-card>
</template>

<style>
.menu__content--select .room-list-last-checked {
  float: right;
  color: rgba(0,0,0,.54);
}
.table__report .activity_column--room_last_checked {
  max-width: 130px;
}
.table__report .activity_column--room_label {
  width: auto;
}
</style>

<script>
import moment from 'moment-business-days'

export default {
  name: 'RoomPicker',
  data() {
    return {
      campusAndRegionSelection: null,
      buildingSelection: null,
      roomSelection: null,
      campusLabels: {
        CHC: "Chicago",
        EVA: "Evanston",
        SFO: "San Francisco",
        QTR: "Qatar"
      }
    };
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    startReport() {
      const roomId = this.roomSelection;
      const teamId = this.teamId;
      this.$router.push({
        path: `/${teamId}/report/${roomId}`
      });
    },
    resetForm() {
      this.campusAndRegionSelection = this.buildingSelection = this.roomSelection = null;
    },
    loadData() {
      this.$roomService.refreshData(this.teamId);
    },
    sortRoomsBySLA(a, b) {
      // TODO: Consider moving this sort to RoomService
      a.last_checked = a.last_checked ? a.last_checked : 0;
      b.last_checked = b.last_checked ? b.last_checked : 0;

      a.minimum_frequency = a.minimum_frequency ? a.minimum_frequency : 90;
      b.minimum_frequency = b.minimum_frequency ? b.minimum_frequency : 90;

      var a_next_check_due = a.last_checked > 0 ? moment(a.last_checked, 'x').businessAdd(a.minimum_frequency).format('X') : moment(0, 'X').format('X');
      var b_next_check_due = b.last_checked > 0 ? moment(b.last_checked, 'x').businessAdd(b.minimum_frequency).format('X') : moment(0, 'X').format('X');

      if(a_next_check_due > b_next_check_due) { // B first
        return 1;
      }
      if(a_next_check_due < b_next_check_due) { // A first
        return -1;
      }
      return 0;
    },
    sortRoomsByLastChecked(a, b) {
      // TODO: Consider moving this sort to RoomService
      a.last_checked = a.last_checked ? a.last_checked : 0;
      b.last_checked = b.last_checked ? b.last_checked : 0;

      if(a.last_checked < b.last_checked) { // A first
        return 1;
      }
      if(a.last_checked > b.last_checked) { // B first
        return -1;
      }
      return 0;
    }
  },
  computed: {
    roomsLoading() {
      return !this.$roomService.rooms.length;
    },
    campusSelection() {
      if(this.campusAndRegionSelection) {
        return this.campusAndRegionSelection.campus_id;
      }
      return null;
    },
    campusRegionSelection() {
      if(this.campusAndRegionSelection) {
        return this.campusAndRegionSelection.campus_region_id;
      }
      return null;
    },
    campuses() {
      var rooms = this.$roomService.rooms;
      var campuses = Array.from(new Set(
        rooms.map(it => {
          var campus = {
            campus_id: it.campus,
            campus_region: it.campus,
            campus_region_id: null,
            label: this.campusLabels[it.campus] || it.campus,
          };
          if(it.campus_region) {
            campus.campus_region_id = it.campus_region;
            campus.label += ' (' + it.campus_region + ')';
            campus.campus_region = it.campus + '_' + it.campus_region;
          }
          return campus;
        }).filter((it, idx, arr) => {
          return arr.map(mapObj => mapObj.campus_region).indexOf(it.campus_region) === idx;
        })
      )).sort();
      return campuses;
    },
    buildings() {
      var rooms = this.$roomService.rooms;
      if(this.campusSelection) {
        rooms = rooms.filter(room => room.campus === this.campusSelection);
      }
      if(this.campusRegionSelection) {
        rooms = rooms.filter(room => room.campus_region === this.campusRegionSelection);
      }
      var buildings = Array.from(new Set(rooms.map(it => it.building))).sort();
      return buildings;
    },
    rooms() {
      var rooms = this.$roomService.rooms;
      if(this.buildingSelection) {
        rooms = rooms.filter(room => room.building === this.buildingSelection);
      }
      if(this.campusSelection) {
        rooms = rooms.filter(room => room.campus === this.campusSelection);
      }
      if(this.campusRegionSelection) {
        rooms = rooms.filter(room => room.campus_region === this.campusRegionSelection);
      }
      rooms = rooms.map(room => {
        var timeAgo = room.last_checked ? moment(room.last_checked, 'x').fromNow() : 'Never'
        // room.selectLabel = '<span class="room-list-label">' + room.label + '</span> <small class="room-list-last-checked caption"><em>Checked: ' + timeAgo + '</em></small>';
        room.selectLabel = room.label + ' (Checked: ' + timeAgo + ')';
        return room;
      }).sort(this.sortRoomsBySLA);
      return rooms;
    },
    recentlyCheckedRooms() {
      return this.$roomService.rooms.sort(this.sortRoomsByLastChecked).splice(0, 10).map(room => {
        room.last_checked_time_ago = room.last_checked ? moment(room.last_checked, 'x').fromNow() : 'Never';
        return room;
      });
    }
  },
  watch: {
    campusSelection(newValue, oldVal) {
      this.buildingSelection = this.roomSelection = null;
    },
    campusRegionSelection(newValue, oldVal) {
      this.buildingSelection = this.roomSelection = null;
    },
    buildingSelection(newValue, oldVal) {
      this.roomSelection = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RoomPicker.vue